import React, { useState, useEffect } from "react";
import { Switch } from "react-router-dom";
import GridContainer from "../../components/Grid/GridContainer";
import OrderConfirmation from "../Consent/OrderConfirmation";
import QuestionOneUI from "../Questions/QuestionOneUI";
import QuestionTwoUI from "../Questions/QuestionTwoUI";
import NotEligible from "../NotEligible/NotEligible";
import Ordered from "../Consent/Ordered";
import { useTheme, Box } from "@mui/material";
import { getStyleForThankyouResponse } from "../styles/commonStyles";
import AlreadyDoneQuestionOneUI from "../AlreadyDoneQuestionnaire/AlreadyDoneQuestionOneUI";
import AlreadyDoneQuestionTwoUI from "../AlreadyDoneQuestionnaire/AlreadyDoneQuestionTwoUI";
import AlreadyDoneQuestionThreeUI from "../AlreadyDoneQuestionnaire/AlreadyDoneQuestionThreeUI";
import ScreeningScheduledQuestionOneUI from "../ScreeningScheduledQuestionnaire/ScreeningScheduledQuestionOneUI";
import ScreeningScheduledQuestionTwoUI from "../ScreeningScheduledQuestionnaire/ScreeningScheduledQuestionTwoUI";
import ScreeningScheduledQuestionThreeUI from "../ScreeningScheduledQuestionnaire/ScreeningScheduledQuestionThreeUI";
import ThankyouResponse from "../ScreeningScheduledQuestionnaire/ThankyouResponse";
const defaultLogo = require("../../assets/images/logo-dark.png");

function OrderLayout(props) {
  const theme = useTheme();
  const classes = getStyleForThankyouResponse(theme);
  const [imageSrc, setImageSrc] = useState();
  const getLogo = () => {
    const organizationId = localStorage.getItem("organizationId");
    const careCenterId = localStorage.getItem("careCenterId");
    let logoImagePath = `${process.env.PUBLIC_URL}/org_assets/org-${organizationId}`;
    if (organizationId == 194 && careCenterId == 431) {
      logoImagePath = logoImagePath + `/care_centers/cc-${careCenterId}`;
    }
    logoImagePath = logoImagePath + "/logo-dark.png";
    setImageSrc(logoImagePath);
  };
  useEffect(() => {
    getLogo();
  }, []);
  return (
    <Box component="div" key="en" sx={classes.commonBgSet}>
      <div>
        <GridContainer justifyContent="center">
          <Box component="div" sx={classes.cardWidth}>
            <Box component="div" sx={classes.textCenter}>
              <Box
                component="img"
                alt=""
                src={imageSrc}
                sx={classes.logoSize}
                onError={() => setImageSrc(defaultLogo)}
              />
            </Box>
            <Switch>
              {props.location.pathname.includes("/questions/1") ? (
                <>
                  <QuestionOneUI {...props} />
                </>
              ) : (
                ""
              )}
              {props.location.pathname.includes("/questions/2") ? (
                <QuestionTwoUI {...props} />
              ) : (
                ""
              )}
              {props.location.pathname.includes("/alreadydone/1") ? (
                <AlreadyDoneQuestionOneUI {...props} />
              ) : (
                ""
              )}
              {props.location.pathname.includes("/alreadydone/2") ? (
                <AlreadyDoneQuestionTwoUI {...props} />
              ) : (
                ""
              )}
              {props.location.pathname.includes("/alreadydone/3") ? (
                <AlreadyDoneQuestionThreeUI {...props} />
              ) : (
                ""
              )}
              {props.location.pathname.includes("/noteligible") ? (
                <NotEligible {...props} />
              ) : (
                ""
              )}
              {props.location.pathname.includes("/orderconfirmation") ? (
                <OrderConfirmation {...props} />
              ) : (
                ""
              )}
              {props.location.pathname.includes("/ordered") ? (
                <Ordered {...props} />
              ) : (
                ""
              )}
              {props.location.pathname.includes("/screeningscheduled/1") ? (
                <ScreeningScheduledQuestionOneUI {...props} />
              ) : (
                ""
              )}
              {props.location.pathname.includes("/screeningscheduled/2") ? (
                <ScreeningScheduledQuestionTwoUI {...props} />
              ) : (
                ""
              )}
              {props.location.pathname.includes("/screeningscheduled/3") ? (
                <ScreeningScheduledQuestionThreeUI {...props} />
              ) : (
                ""
              )}
              {props.location.pathname.includes(
                "/screeningscheduled/thankyouresponse"
              ) ? (
                <ThankyouResponse {...props} />
              ) : (
                ""
              )}
            </Switch>
          </Box>
        </GridContainer>
      </div>
    </Box>
  );
}
export default OrderLayout;
